export default __webpack_public_path__ + "static/media/park9.905df46f.jpg";